import React from "react";
import I18n from "i18n-js";

import ActionButton from "../../../commons/ActionButton";

import editIcon from "../../../assets/icons/edit.svg";

const EditTeamButton = ({ team }) => {
  return (
    <ActionButton
      title={I18n.t("dashboard.actions.edit_team")}
      icon={editIcon}
      href={`/teams/${team.uuid}/users?locale=${I18n.locale}`}
    />
  );
}

export default EditTeamButton;
